(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["micase-instala-protector"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mc-install]').forEach((root) => {
    if (root.dataset.videoReady === 'true') return;
    root.dataset.videoReady = 'true';
    const dialog = root.querySelector('.mcinstall__dialog');
    const iframe = dialog?.querySelector('iframe');
    const title = dialog?.querySelector('.mcinstall__dialog-head h2');
    const closeButton = dialog?.querySelector('.mcinstall__dialog-close');
    if (!dialog || !iframe || !title || !closeButton) return;
    const clearVideo = () => { iframe.removeAttribute('src'); };
    root.querySelectorAll('[data-video-id]').forEach((button) => {
      button.addEventListener('click', () => {
        const provider = button.dataset.videoProvider;
        const id = button.dataset.videoId;
        title.textContent = button.dataset.videoTitle || title.textContent;
        iframe.src = provider === 'vimeo'
          ? `https://player.vimeo.com/video/${id}?autoplay=1`
          : `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
        dialog.showModal();
      });
    });
    closeButton.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', clearVideo);
    dialog.addEventListener('click', (event) => {
      const rect = dialog.getBoundingClientRect();
      const outside = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      if (outside) dialog.close();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["micase-promo-recordatorio"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root=document.querySelector('[data-mcpr]');
    if(!root)return;
    var configNode=document.getElementById(root.getAttribute('data-config'));
    if(!configNode)return;
    var cfg;
    try{cfg=JSON.parse(configNode.textContent||'{}')}catch(e){return}
    var dialog=root.querySelector('.mcprem__dialog');
    var title=root.querySelector('[data-mcpr-title]');
    var body=root.querySelector('[data-mcpr-body]');
    var countNode=root.querySelector('[data-mcpr-count]');
    var totalNode=root.querySelector('[data-mcpr-total]');
    var primary=root.querySelector('[data-mcpr-primary]');
    var checkout=root.querySelector('[data-mcpr-checkout]');
    var steps=root.querySelectorAll('.mcprem__steps span');
    var rail=root.querySelector('[data-mcpr-rail]');
    var cart=null;
    var previousCount=null;
    var open=false;
    var timer=null;
    var previousFocus=null;
    var previousOverflow='';
    var storageKey='micase_promo_recordatorio_'+(cfg.key||'actual');
    var surfaceKey='micase_promo_modal_last';
    var modalGap=Math.max(5,parseInt(cfg.modalGap||10,10))*60000;

    function rootUrl(){return window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root?window.Shopify.routes.root:'/'}
    function money(cents){try{return new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',maximumFractionDigits:0}).format((cents||0)/100)}catch(e){return'$'+Math.round((cents||0)/100).toLocaleString('es-CO')}}
    function pairLabel(pairs){return pairs===1?'tu primer 2×1':pairs+' pares 2×1'}
    function replacePairs(value,pairs,quantity){
      var products=Math.max(0,parseInt(quantity,10)||0),free=cfg.repeatPairs?Math.floor(products/2):(products>=2?1:0),paid=products-free,next=products+1,nextFree=cfg.repeatPairs?Math.floor(next/2):(next>=2?1:0),nextPaid=next-nextFree;
      return String(value||'')
        .split('{pares}').join(pairLabel(pairs))
        .split('{productos}').join(String(products))
        .split('{pagas}').join(String(paid))
        .split('{siguiente}').join(String(next))
        .split('{pagas_siguiente}').join(String(nextPaid));
    }
    function store(){return cfg.frequency==='day'?window.localStorage:window.sessionStorage}
    function seen(){if(cfg.editor||cfg.frequency==='always')return false;try{var v=parseInt(store().getItem(storageKey)||'0',10);return cfg.frequency==='day'?v&&Date.now()-v<86400000:!!v}catch(e){return false}}
    function mark(){if(cfg.editor||cfg.frequency==='always')return;try{store().setItem(storageKey,String(Date.now()))}catch(e){}}
    function surfaceGet(){if(cfg.editor)return 0;try{return parseInt(window.sessionStorage.getItem(surfaceKey)||'0',10)||0}catch(e){return 0}}
    function surfaceMark(){if(cfg.editor)return;try{window.sessionStorage.setItem(surfaceKey,String(Date.now()))}catch(e){}}
    function surfaceWait(){return Math.max(0,modalGap-(Date.now()-surfaceGet()))}
    function allowedPage(){return !((cfg.template==='index'&&!cfg.showHome)||(cfg.template==='cart'&&!cfg.showCart))}
    function busy(){
      if(document.querySelector('cart-drawer.active,.drawer.active,.mc2:not([hidden]),.mc-pop-on:not(#mcpg)'))return true;
      var dialogs=document.querySelectorAll('[role="dialog"]:not(.mcprem__dialog)');
      for(var i=0;i<dialogs.length;i++)if(dialogs[i].getClientRects().length)return true;
      return false;
    }
    function setState(){
      if(!cart)return;
      var n=parseInt(cart.item_count,10)||0;
      var isTwo=cfg.type==='2x1';
      var ready=isTwo&&n>=2;
      var pairs=Math.floor(n/2);
      var repeatOne=ready&&cfg.repeatPairs&&n%2===1;
      var repeatReady=ready&&cfg.repeatPairs&&n%2===0;
      if(isTwo&&n<2){
        title.textContent=cfg.oneTitle;
        body.textContent=cfg.oneBody;
        primary.textContent=cfg.oneCta;
        primary.setAttribute('href',cfg.url||'/collections/all');
        checkout.hidden=true;
      }else if(repeatOne){
        title.textContent=replacePairs(cfg.repeatOneTitle,pairs,n);
        body.textContent=replacePairs(cfg.repeatOneBody,pairs,n);
        primary.textContent=cfg.repeatOneCta;
        primary.setAttribute('href',cfg.url||'/collections/all');
        checkout.textContent=cfg.asksForCode?cfg.readyCta:cfg.checkoutCta;
        checkout.setAttribute('href',cfg.asksForCode?'#micase-2x1':'/checkout');
        checkout.hidden=false;
      }else if(repeatReady){
        title.textContent=replacePairs(cfg.repeatReadyTitle,pairs,n);
        body.textContent=replacePairs(cfg.repeatReadyBody,pairs,n);
        primary.textContent=cfg.repeatReadyCta;
        primary.setAttribute('href',cfg.url||'/collections/all');
        checkout.textContent=cfg.asksForCode?cfg.readyCta:cfg.checkoutCta;
        checkout.setAttribute('href',cfg.asksForCode?'#micase-2x1':'/checkout');
        checkout.hidden=false;
      }else if(isTwo){
        title.textContent=cfg.readyTitle;
        body.textContent=cfg.readyBody;
        primary.textContent=cfg.asksForCode?cfg.readyCta:cfg.checkoutCta;
        primary.setAttribute('href',cfg.asksForCode?'#micase-2x1':'/checkout');
        checkout.hidden=!cfg.asksForCode;
      }else{
        title.textContent=cfg.title||'';
        body.textContent=cfg.body||'';
        primary.textContent=cfg.cta||cfg.checkoutCta;
        primary.setAttribute('href',cfg.asksForCode?'#micase-2x1':'/checkout');
        checkout.hidden=!cfg.asksForCode;
      }
      countNode.textContent=n+' '+(n===1?'producto':'productos')+' en tu carrito';
      totalNode.textContent=money(cart.total_price);
      var stepDone=cfg.repeatPairs&&n>2?(n%2===0?2:1):Math.min(n,2);
      var stepStart=cfg.repeatPairs&&n>2?(n%2===0?n-1:n):1;
      for(var i=0;i<steps.length;i++){
        steps[i].classList.toggle('is-done',i<stepDone);
        steps[i].lastChild.nodeValue='Producto '+(stepStart+i);
      }
      root.querySelector('[data-mcpr-steps]').hidden=!isTwo;
      rail.style.width=(isTwo?(stepDone*50):100)+'%';
    }
    function show(force){
      clearTimeout(timer);
      if(open||!cart||!cart.item_count)return false;
      if(!force&&(seen()||!allowedPage()))return false;
      if(!force&&surfaceWait()>0){arm(Math.ceil(surfaceWait()/1000)+1);return false}
      if(!force&&busy()){arm(15);return false}
      setState();
      open=true;
      previousFocus=document.activeElement;
      root.hidden=false;
      mark();
      surfaceMark();
      previousOverflow=document.documentElement.style.overflow;
      document.documentElement.style.overflow='hidden';
      setTimeout(function(){if(primary)primary.focus({preventScroll:true})},40);
      return true;
    }
    function close(){
      if(!open)return;
      open=false;
      root.hidden=true;
      document.documentElement.style.overflow=previousOverflow;
      if(previousFocus&&previousFocus.focus)try{previousFocus.focus({preventScroll:true})}catch(e){}
    }
    function arm(seconds){clearTimeout(timer);if(cfg.editor||seen()||!allowedPage()||!cart||!cart.item_count)return;timer=setTimeout(function(){show(false)},Math.max(5,seconds||cfg.delay||18)*1000)}
    function accept(next){
      if(!next)return;
      var nextCount=parseInt(next.item_count,10)||0;
      var added=previousCount!==null&&nextCount>previousCount;
      cart=next;
      previousCount=nextCount;
      if(open)setState();
      if(added)arm(cfg.delay);
    }
    function fetchCart(){fetch(rootUrl()+'cart.js',{headers:{Accept:'application/json'}}).then(function(r){if(!r.ok)throw new Error('cart');return r.json()}).then(accept).catch(function(){})}
    root.querySelectorAll('[data-mcpr-close]').forEach(function(n){n.addEventListener('click',close)});
    primary.addEventListener('click',function(){close()});
    checkout.addEventListener('click',function(){close()});
    document.addEventListener('keydown',function(e){
      if(!open)return;
      if(e.key==='Escape'){close();return}
      if(e.key!=='Tab')return;
      var focusable=root.querySelectorAll('button:not([disabled]),a[href]');
      if(!focusable.length)return;
      var first=focusable[0],last=focusable[focusable.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
    });
    document.addEventListener('cart:updated',fetchCart);
    document.addEventListener('micase:cart-updated',fetchCart);
    document.addEventListener('submit',function(e){if(e.target&&e.target.matches&&e.target.matches('form[action*="/cart/add"],.mccombo__f,.mcxf__f'))setTimeout(fetchCart,650)},true);
    if(window.MCcarrito&&typeof window.MCcarrito.on==='function')window.MCcarrito.on(accept);
    if(cfg.editor){
      cart={item_count:1,total_price:4990000};
      document.addEventListener('shopify:section:select',function(e){if(e.target&&e.target.contains&&e.target.contains(root))show(true)});
      document.addEventListener('shopify:section:deselect',function(e){if(e.target&&e.target.contains&&e.target.contains(root))close()});
    }
    var scrolled=false;
    window.addEventListener('scroll',function(){
      if(cfg.editor||scrolled||seen()||!allowedPage()||!cart||!cart.item_count)return;
      var h=document.documentElement.scrollHeight-window.innerHeight;
      if(h>0&&window.scrollY/h*100>=cfg.scroll){scrolled=true;if(!show(false))arm(15)}
    },{passive:true});
    fetch(rootUrl()+'cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(c){
      cart=c;
      previousCount=parseInt(c.item_count,10)||0;
      if(cfg.editor){if(!cart.item_count)cart={item_count:1,total_price:4990000};return}
      if(cfg.priorCart&&cart.item_count)arm(cfg.delay+8);
    }).catch(function(){});
  })();

  } catch(e) { console.error(e); }
})();
})();
